module.exports = __webpack_public_path__ + "static/media/cutRed.e4ed241e.svg";